import React, { useMemo } from 'react'

import { NameChipColors } from 'constants/color'
import { _userInfo } from 'store/selectors/User'

import { Container, Text } from './styles'

const getRandomNameChipColor = () =>
    NameChipColors[Math.floor(NameChipColors.length * Math.random())]

const Namechip = ({ identity, isAway, isLocal }) => {
    const { firstName } = identity
    const color = useMemo(() => getRandomNameChipColor(), [])

    return (
        <Container color={color} className={isAway ? 'elsewhere' : ''}>
            <Text>{isLocal ? 'you' : firstName}</Text>
        </Container>
    )
}

export { Namechip }
